import { v4 as uuidv4 } from 'uuid';

const brandCarouselOneData = [
    {
        id: uuidv4(),
        brand: '/img/brand/ainal.png',
        name: 'Ain Al Khaleej Hospital'
    },
    {
        id: uuidv4(),
        brand: '/img/brand/aldur.png',
        name: 'AL DURRAH TOWER'
    },
    {
        id: uuidv4(),
        brand: '/img/brand/alshira.png',
        name: 'Al Shirawi FM'
    },
    {
        id: uuidv4(),
        brand: '/img/brand/ecf.png',
        name: 'ECF Middle East'
    },
    {
        id: uuidv4(),
        brand: '/img/brand/enova.png',
        name: 'ENOVA by VEOLIA'
    },
    {
        id: uuidv4(),
        brand: '/img/brand/fbm.png',
        name: 'fbmhudson FZE'
    },
    {
        id: uuidv4(),
        brand: '/img/brand/kempi.png',
        name: 'Kempinski'
    },
    {
        id: uuidv4(),
        brand: '/img/brand/mtc.png',
        name: 'Magnum Technology Center'
    },
    {
        id: uuidv4(),
        brand: '/img/brand/prism.png',
        name: 'PRISM TECH ENGINEERING'
    },
    {
        id: uuidv4(),
        brand: '/img/brand/rak.png',
        name: 'RAK real estate'
    },
    {
        id: uuidv4(),
        brand: '/img/brand/safemax.png',
        name: 'SAFE MAX'
    },
    {
        id: uuidv4(),
        brand: '/img/brand/vis.png',
        name: 'Vernus International School'
    },
    {
        id: uuidv4(),
        brand: '/img/brand/canadian2.png',
        name: 'Canadian University Dubai'
    },
    {
        id: uuidv4(),
        brand: '/img/brand/enoc1.png',
        name: 'ENOC'
    },
    {
        id: uuidv4(),
        brand: '/img/brand/majid1.png',
        name: 'Majid Al Futtaim'
    },
    {
        id: uuidv4(),
        brand: '/img/brand/masafi1.png',
        name: 'masafi'
    },
    {
        id: uuidv4(),
        brand: '/img/brand/melubco1.png',
        name: 'MELUBCO'
    },
    {
        id: uuidv4(),
        brand: '/img/brand/munawel1.png',
        name: 'Munawel interiors llc'
    },
    {
        id: uuidv4(),
        brand: '/img/brand/vopak1.png',
        name: 'Vopak Horizon Fujairah Limited'
    },
    {
        id: uuidv4(),
        brand: '/img/brand/alhab.png',
        name: 'Al Habtoor'
    },
    {
        id: uuidv4(),
        brand: '/img/brand/gorica.png',
        name: 'Gorica'
    },
];

export default brandCarouselOneData;
